// src/hooks/useApi.js
import { useState, useCallback } from 'react';
import { apiFetch, API_BASE } from '../utils/api';

export function useApi() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async (path, opts = {}) => {
    setLoading(true);
    setError(null);
    try {
      const resp = await apiFetch(path, opts);
      return resp;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { request, loading, error, backendUrl: API_BASE };
}
